import * as i0 from '@angular/core';
import { InjectionToken, Component, Inject, Input, NgModule } from '@angular/core';

const CHAT_ENV = new InjectionToken('');

function getURLs(environment, lang, customerType) {
    const urls = {
        snapInScript: `https://lampiris-be.my.salesforce-sites.com/resource/SnapInMessaging_${lang.toUpperCase()}`,
        bootstrapScript: 'https://lampiris-be.my.site.com/ESWMessagingWebDeployment/assets/js/bootstrap.min.js'
    };
    const env = environment.toLowerCase();
    const customerTypeSuffix = customerType === CustomerType.B2B ? `_${CustomerType.B2B}` : '';
    if (env === 'prod') {
        urls.snapInScript += customerTypeSuffix;
        return urls;
    }
    const suffix = `_${env.includes('die') ? 'DIE' : (env.includes('silver') ? 'BAESILVER' : 'BAEGOLD')}`;
    const bootstrapDomain = `${env.includes('die') ? 'totalenergies-be--oscia.sandbox' : (env.includes('silver') ? 'totalenergies-be--silver.sandbox' : 'totalenergies-be--baegold.sandbox')}`;
    urls.snapInScript += customerTypeSuffix + suffix;
    urls.bootstrapScript = urls.bootstrapScript.replace('lampiris-be', bootstrapDomain);
    return urls;
}

var CustomerType;
(function (CustomerType) {
    CustomerType["B2B"] = "B2B";
    CustomerType["B2C"] = "B2C";
})(CustomerType || (CustomerType = {}));
class SalesforceChatComponent {
    constructor(ENV) {
        this.customerType = CustomerType.B2C;
        this.class = 'live-chat-loader';
        this.env = ENV;
    }
    ngOnInit() { }
    ngOnChanges(changes) {
        const { lang, customerType } = changes;
        const langChanges = lang === undefined ? this.lang : lang?.currentValue;
        const customerTypeChanges = customerType === undefined ? this.customerType : customerType?.currentValue;
        if ((this.env && lang?.currentValue !== lang?.previousValue) ||
            (this.env && customerType?.currentValue !== customerType?.previousValue)) {
            this.urls = getURLs(this.env, langChanges, customerTypeChanges);
        }
        if (this.urls) {
            if ((lang?.currentValue &&
                lang?.previousValue &&
                lang?.currentValue !== lang?.previousValue) ||
                (customerType?.currentValue &&
                    customerType?.previousValue &&
                    customerType?.currentValue !== customerType?.previousValue)) {
                if (window?.$A || window?.AuraLocker) {
                    return;
                }
                this.resetChatAndLoadScripts();
            }
            else {
                this.loadScripts();
            }
        }
    }
    async resetChatAndLoadScripts() {
        this.resetSalesForceChatInstance();
        this.cleanJunk(); // Delete all tags
        await this.sleep(500);
        this.loadScripts();
    }
    sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }
    loadJavascript(url, onload) {
        if (url) {
            const jsFile = document.createElement('script');
            jsFile.className += this.class;
            jsFile.src = url;
            jsFile.type = 'text/javascript';
            if (onload) {
                jsFile.setAttribute('onload', onload);
            }
            document.body.appendChild(jsFile);
        }
    }
    loadScripts() {
        this.loadJavascript(this.urls?.snapInScript);
        this.loadJavascript(this.urls?.bootstrapScript, 'initEmbeddedMessaging()');
    }
    resetSalesForceChatInstance() {
        if (window.embedded_svc) {
            window.embedded_svc.liveAgentAPI.clearSession();
            window.embedded_svc.liveAgentAPI.endChat();
            window['embedded_svc'] = null;
            delete window['embedded_svc'];
        }
        if (window.embeddedservice_bootstrap) {
            window.embeddedservice_bootstrap.userVerificationAPI.clearSession();
            window.embeddedservice_bootstrap.removeMarkup();
            window['embeddedservice_bootstrap'] = null;
            delete window['embeddedservice_bootstrap'];
        }
    }
    cleanJunk() {
        var chatElements = document.querySelectorAll('script[src*="salesforce"], script[src*="salesforceliveagent"], script[src*="embedded_svc"], script[src*="SnapInMessaging"], script[src*="ESWMessagingWebDeployment"], script[src*="static.lightning"], script[src*="testlivechat"], link[href*="testlivechat"], link[href*="embeddedservice"], #auraErrorMessage, #inert-style, .embeddedServiceHelpButton, .embeddedServiceSidebar, .embeddedServiceMainContainer, .embeddedMessagingSiteContextFrame, .embedded-messaging, .live-chat-loader, .live-chat-loader-style, .pac-logo, #inert-script, #invite-esw-script, #esw_storage_iframe, #fileUploadForm, #fileUploadIframe, #liveagent-esw-script, #common-script, #_hjRemoteVarsFrame, [src*="embeddedservice"], script[src*="salesforceliveagent"], link[href*="salesforceliveagent"], iframe[id^="liveagent"], #liveagent_button_online, #liveagent_button_offline, #liveAgentSfdcChatWindow, #liveAgentSfdcVisitorPanel, #liveAgentSfdcChatInputArea, #liveAgentSfdcSendButton, #liveAgentSfdcChatLog, #liveAgentSfdcChatForm, #liveAgentSfdcContainer, #liveAgentSfdcCloseButton');
        // Supprimer tous les éléments du chat
        for (var i = 0; i < chatElements.length; i++) {
            chatElements[i].remove();
        }
    }
}
SalesforceChatComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: SalesforceChatComponent, deps: [{ token: CHAT_ENV }], target: i0.ɵɵFactoryTarget.Component });
SalesforceChatComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.2.6", type: SalesforceChatComponent, selector: "lib-salesforce-chat", inputs: { lang: "lang", customerType: "customerType" }, usesOnChanges: true, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: SalesforceChatComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-salesforce-chat',
                    template: '',
                    styles: [],
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [CHAT_ENV]
                }] }]; }, propDecorators: { lang: [{
                type: Input
            }], customerType: [{
                type: Input
            }] } });

class SalesforceChatModule {
}
SalesforceChatModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: SalesforceChatModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SalesforceChatModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: SalesforceChatModule, declarations: [SalesforceChatComponent], exports: [SalesforceChatComponent] });
SalesforceChatModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: SalesforceChatModule, imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.2.6", ngImport: i0, type: SalesforceChatModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SalesforceChatComponent
                    ],
                    imports: [],
                    exports: [
                        SalesforceChatComponent
                    ]
                }]
        }] });

/*
 * Public API Surface of salesforce-chat
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CHAT_ENV, CustomerType, SalesforceChatComponent, SalesforceChatModule };
